
import React from "react";
import BetForm from "../components/BetForm";

export default function BetPage() {
    return (
        <BetForm/>
    );
}
